export default {"src":"/_next/static/media/changeCrible.f0c10522.svg","height":20,"width":22,"blurWidth":0,"blurHeight":0};